<app-layout>
  <div class="report-viewer-page">
    <mat-toolbar class="page-header" role="heading">
      <div class="page-header-title">
        <div class="page-header-copy">
          <span class="eyebrow" appLocalizationPopupDirective localizationCode="Reports">
            {{ 'Reports' | translate: {Default: 'Reports'} }}
          </span>
          <h1 appLocalizationPopupDirective localizationCode="ReportViewer">
            {{ 'ReportViewer' | translate: {Default: 'Report Viewer'} }}
          </h1>
        </div>
      </div>

      <button
        mat-stroked-button
        setColor="primaryColour"
        color="primary"
        appPreventDoubleClick
        (throttledClick)="goBack()"
        matTooltip="{{ 'BackToReports' | translate: {Default: 'Back to Reports'} }}"
        appLocalizationPopupDirective
        localizationCode="BackToReports"
      >
        <mat-icon aria-hidden="false" class="material-icons-outlined">arrow_back</mat-icon>
        {{ 'BackToReports' | translate: {Default: 'Back to reports'} }}
      </button>
    </mat-toolbar>

    <div class="report-viewer-shell">
      <div *ngIf="errorMessage" class="report-viewer-error">
        {{ errorMessage }}
      </div>

      <div class="report-viewer-container">
        <div id="reportViewer" class="report-viewer-root"></div>
      </div>
    </div>
  </div>
</app-layout>
